// extracted by mini-css-extract-plugin
export default {"grupoInputBtn":"Formulario_grupoInputBtn__lvTTf","alerta":"Formulario_alerta__W5maj","erro":"Formulario_erro__aO511","grupo-input-btn":"Formulario_grupo-input-btn__krXO0"};